module.exports = __webpack_public_path__ + "static/media/insights2023-10-25.ae4fe4c5.png";